"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedFeatureList = instanceOfPaginatedFeatureList;
exports.PaginatedFeatureListFromJSON = PaginatedFeatureListFromJSON;
exports.PaginatedFeatureListFromJSONTyped = PaginatedFeatureListFromJSONTyped;
exports.PaginatedFeatureListToJSON = PaginatedFeatureListToJSON;
exports.PaginatedFeatureListToJSONTyped = PaginatedFeatureListToJSONTyped;
const feature_1 = require("./feature");
/**
 * Check if a given object implements the PaginatedFeatureList interface.
 */
function instanceOfPaginatedFeatureList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedFeatureListFromJSON(json) {
    return PaginatedFeatureListFromJSONTyped(json, false);
}
function PaginatedFeatureListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(feature_1.FeatureFromJSON)),
    };
}
function PaginatedFeatureListToJSON(json) {
    return PaginatedFeatureListToJSONTyped(json, false);
}
function PaginatedFeatureListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(feature_1.FeatureToJSON)),
    };
}
//# sourceMappingURL=paginatedFeatureList.js.map